import api from '../api';
import { EventData } from '../../components/slices/WellNoteSlice';
import { createWrapperPayload, wrapperConstants } from '../wrapper-api';

interface CommentsResponse {
  id: string;
  date: string;
  source: string;
  userId: string;
  category: string;
  note: string;
}
interface WellCommentApiResponse {
  id?: number | string;
  comments?: [CommentsResponse];
  noteId?: string;
  assetGuid?: string;
  dateCreated?: string;
}

export async function fetchWellCommentEvents(wellId: number): Promise<EventData[]> {
  const params: Record<string, string | number> = { wellId };

  const requestPayload = createWrapperPayload('POST', `/api/comments/${wellId}`, {
    params,
  });

  const response = await api.post(wrapperConstants.router, requestPayload);

  // Transform API response to map WellNoteId to id
  const rawData = response.data.Data || [];
  console.log('GetWellComments API raw response:', rawData);

  const transformedData: EventData[] = rawData.map((item: WellCommentApiResponse) => ({
    ...item,
    id: item.noteId || item.id || '', // Map WellNoteId from API response to id field
    dateCreated: item.dateCreated,
    noteId: item.noteId,
    assetGuid: item.assetGuid,
    comments: item.comments,
  }));

  console.log('GetWellComments transformed data:', transformedData);
  return transformedData;
}
